import React, { useState } from 'react'
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Tooltip,
    Switch,
} from '@chakra-ui/react'
import { VscEdit } from 'react-icons/vsc'
import { useDispatch } from 'react-redux';
import { updatePermiso, getPermisos } from '../../features/permisoSlice';


export const ModalEditarPermiso = ({ row, page, perPage }) => {

    const dispatch = useDispatch();


    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        key: '',
        descripcion: '',
        estado: null
    }

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = (data) => {
        setIsModalOpen(true);
        setIndice({ ...data }); // ✅ Clona el objeto para evitar referencias circulares
    };

    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    const handleUpdate = (indice) => {
        dispatch(updatePermiso(indice)).then(() => {
            dispatch(getPermisos({ page, perPage })); // Usa los valores pasados como props y Actualiza la tabla después de eliminar
            setIsModalOpen(false); // Cierra el modal
        });
    };
    // Validación del formulario
    const isFormValid = !!indice.key?.trim() && !!indice.descripcion?.trim() && indice.estado !== null;

    return (
        <>
            <Tooltip hasArrow label='Editar' placement='auto'>
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit}
                        fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR PERMISO</ModalHeader>
                    <ModalCloseButton />
                     <ModalBody>
                        

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <Text fontWeight="semibold">ESTADO</Text>
                            <Switch onChange={(e) => setIndice({ ...indice, estado: e.target.checked })} value={indice ? indice.estado : null} colorScheme="purple" isChecked={indice.estado === true ? true : false} size='lg' />
                         </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.key : ''}
                                        placeholder="Ingrese el nombre del permiso"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, key: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight="semibold">DESCRIPCION</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.descripcion : ''}
                                        placeholder="Ingrese la descripción del permiso"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                    />
                            </FormControl>
                            
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
             
                        </Stack>

                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            size="lg"
                            mr={3}
                            onClick={() => handleUpdate(indice)} // ✅ Ahora pasa `indice`
                            borderRadius="xl"
                            isDisabled={!isFormValid}
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
